import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";

const style = document.createElement("style");
style.textContent = `.hz-swal-confirm {
  background: var(--hz-cta, var(--hz-cta)) !important;
  color: var(--hz-surface) !important;
  border: none !important;
  border-radius: 999px !important;
  padding: 12px 18px !important;
  font-weight: 800 !important;
  box-shadow: 0 4px 18px var(--shadow-cta-md) !important;
  transition: all 0.2s ease !important;
}
.hz-swal-confirm:hover {
  background: var(--color-retail-secondary, var(--hz-green-hover)) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 28px var(--shadow-cta-hover) !important;
}
.hz-swal-confirm:focus {
  outline: none !important;
  box-shadow: 0 0 0 4px var(--shadow-focus-ring), 0 8px 28px var(--shadow-cta-md) !important;
}
.hz-swal-cancel {
  background: var(--hz-input, var(--hz-bg)) !important;
  color: var(--hz-navy, var(--hz-navy)) !important;
  border: 1px solid var(--hz-border, var(--hz-border)) !important;
  border-radius: 999px !important;
  padding: 12px 18px !important;
  font-weight: 700 !important;
}
.hz-swal-icon {
  color: var(--hz-cta, var(--hz-cta)) !important;
  border: 2px solid var(--glow-primary-55) !important;
  border-radius: 50% !important;
  padding: 10px !important;
  background-color: var(--glow-primary-12) !important;
}`;
document.head.appendChild(style);

export const hzSwal = Swal.mixin({
  customClass: {
    confirmButton: "hz-swal-confirm",
    cancelButton: "hz-swal-cancel",
  },
});

export const showAlertWithConfirmCancel = ({
  msgTitle,
  msgText,
  html,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  SweetAlert.fire({
    title: msgTitle || "האם את/ה בטוח/ה?",
    text: msgText || "",
    html: html || "",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText || "אישור",
    cancelButtonText: cancelText || "ביטול",
    reverseButtons: true,
    customClass: {
      confirmButton: "hz-swal-confirm",
      cancelButton: "hz-swal-cancel",
    },
    didOpen: () => {
      document.body.classList.add("hz-alert-open");
    },
    willClose: () => {
      document.body.classList.remove("hz-alert-open");
    },
  }).then((result) => {
    if (result.isConfirmed) {
      if (onConfirm) onConfirm();
    } else if (onCancel) {
      onCancel();
    }
  });
};

export const showAlertWithConfirm = ({
  msgHtml,
  msgTitle,
  msgText,
  confirmButton,
  confirmText,
  msgType,
  onConfirm,
  allowOutsideClick = true,
  allowEscapeKey = true,
}) => {
  Swal.fire({
    ...(msgTitle ? { title: msgTitle } : {}),
    ...(msgText ? { text: msgText } : {}),
    html: msgHtml ? msgHtml : !msgTitle && !msgText ? "<div></div>" : undefined,
    showConfirmButton: confirmButton !== undefined ? confirmButton : true,
    confirmButtonText: confirmText ? confirmText : "עבור לתשלום",
    showCloseButton: false,
    icon: msgType ? msgType : "info",
    allowOutsideClick,
    allowEscapeKey,
    customClass: {
      confirmButton: "hz-swal-confirm",
      cancelButton: "hz-swal-cancel",
      icon: "hz-swal-icon",
    },
    didOpen: () => {
      document.body.classList.add("hz-alert-open");
    },
    willClose: () => {
      document.body.classList.remove("hz-alert-open");
    },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};

const showAlert = ({
  msgTitle,
  msgText,
  msgType,
  msgTimer,
  allowOutsideClick = true,
} = {}) => {
  SweetAlert.fire({
    icon: msgType ? msgType : "error",
    title: msgTitle ? msgTitle : "שגיאה בחיבור לרשת",
    text:
      msgText !== undefined && msgText !== null
        ? msgText
        : msgTitle
          ? ""
          : "בבקשה נסה שוב מאוחר יותר",
    timer: msgTimer ? msgTimer : 5000,
    allowOutsideClick,
    showConfirmButton: false,
    didOpen: () => {
      document.body.classList.add("hz-alert-open");
      const iconElement = document.querySelector(".swal2-icon");
      if (iconElement) {
        iconElement.style.cursor = "pointer";
        iconElement.addEventListener("click", () => {
          SweetAlert.close();
        });
      }
    },
    willClose: () => {
      document.body.classList.remove("hz-alert-open");
    },
  });
};

export default showAlert;

export const showAlertHTML = (msgHtml) => {
  SweetAlert.fire({
    html: msgHtml,
    showConfirmButton: false,
    showCloseButton: true,
  });
};
